// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_gf-6";
export var emphasizeQuantity = "_gf-3";
export var flatBottomCorners = "_gf-5";
export var productImage = "_gf-0";
export var quantityContainer = "_gf-2";
export var tooltip = "_gf-1";
export var wrapAndEllipsesOverflow = "_gf-4";